import { configureStore } from '@reduxjs/toolkit'
import counterReducer from "./myFeatureSlice";
import authReducer from "./authSlice";
import albumsReducer from "./albumsSlice";

/*
    HOW REDUX WORKS ?
       store [Book]
         - slice [page]

       slice []
        - name
        - initialState
        - reducers (fn) state => newState

        UI -> action (type, payload) -> store -> initialState -> reducer (takes action and changes state) -> newState
 */

const store =  configureStore({
    reducer: {
        counter: counterReducer,
        auth: authReducer,
        albums: albumsReducer
    }

})

// Infer the `RootState`,  `AppDispatch`, and `AppStore` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
export type AppStore = typeof store

export default store;